<template>
  <Scaffold />
</template>

<script>
import { mapState } from 'vuex';

import Scaffold from '@/components/layouts/Scaffold.vue';
import { appCallbackRoute, appId, ssoAuthentication } from '@/api/workflow';

export default {
  name: 'Home',
  components: {
    Scaffold
  },
  computed: {
    ...mapState({
      loading: state => state.identity.loading,
      user: state => state.identity.user
    })
  },
  mounted() {
    if (this.user) {
      appCallbackRoute(appId())
        .then(route => {
          this.$router.push({ name: route });
        })
        .catch(err => {
          this.$router.push({ name: 'connection' });
        });
    } else {
        this.$router.push({ name: 'connection' });
    }
  }
};
</script>
